import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
// Component imports
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import FeaturesSection from './components/FeaturesSection';
import PricingSection from './components/PricingSection';
import SignUpSection from './components/SignUpSection';
import Footer from './components/Footer';
import NewsletterPopup from './components/NewsletterPopup';
import LoginSignup from './components/LoginSignup';
import Dashboard from './components/Dashboard';
// Hook imports
import { useNewsletterPopup } from './hooks/useNewsletterPopup';

// Landing Page Component
const LandingPage: React.FC = () => {
  const { isVisible, hidePopup } = useNewsletterPopup();

  return (
    <>
      <Navigation />
      <Hero />
      <ProductSection />
      <FeaturesSection />
      <PricingSection />
      <SignUpSection />
      <Footer />
      
      {/* Newsletter Popup - shows once per new visitor */}
      <NewsletterPopup isVisible={isVisible} onClose={hidePopup} />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginSignup />} />
        <Route path="/signup" element={<LoginSignup />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </div>
  );
}

export default App;
